module.exports = __webpack_public_path__ + "static/media/paypal.0695a7b6.svg";